<script lang="ts">
	import {
		faCommentDots,
		faFilm,
		faLayerGroup,
		faSquarePollVertical
	} from '@fortawesome/free-solid-svg-icons';
	import Section from '$lib/shared/ui/Section.svelte';
	import SectionHeading from '$lib/shared/ui/SectionHeading.svelte';
	import FeatureTile from '$lib/shared/ui/FeatureTile.svelte';
	import Reveal from '$lib/shared/ui/Reveal.svelte';

	// `wide` tiles span two columns and carry the brand gradient, breaking the
	// grid out of a flat 4-equal-card row into an asymmetric bento rhythm.
	const features = [
		{
			icon: faCommentDots,
			title: 'AI Voice Conversations',
			description:
				'Paid AI voice chats let viewers create characters and shape the conversation live on your stream.',
			wide: true
		},
		{
			icon: faFilm,
			title: 'Character Animations',
			description:
				'Custom animations sync to each voice chat, so fans direct the story as it plays out.',
			wide: false
		},
		{
			icon: faLayerGroup,
			title: 'Custom Overlays',
			description:
				'Personalized overlays match your brand and make every alert feel like part of the show.',
			wide: false
		},
		{
			icon: faSquarePollVertical,
			title: 'Interactive Surveys & Triggers',
			description:
				'Real-time polls and triggered events hand the action to your viewers and keep the room alive.',
			wide: true
		}
	];
</script>

<Section id="features">
	<Reveal class="w-full">
		<SectionHeading title="Everything you need for an interactive show" accent="interactive show">
			Tools built for content creators who want deeper, more engaging live shows.
		</SectionHeading>
	</Reveal>

	<div class="mt-12 grid w-full grid-cols-1 gap-5 sm:mt-16 md:grid-cols-2 lg:grid-cols-3">
		{#each features as feature, i (feature.title)}
			<Reveal delay={i * 80} class={feature.wide ? 'md:col-span-2' : ''}>
				<FeatureTile
					icon={feature.icon}
					title={feature.title}
					description={feature.description}
					wide={feature.wide}
				/>
			</Reveal>
		{/each}
	</div>
</Section>
